import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldCheck, Lock } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

export default function Header() {
  const location = useLocation();
  const isDonationPage = location.pathname === '/donate';

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/donate" className="flex items-center gap-3">
            <img 
              src="/logo.png" 
              alt="If You Teach Me Inc." 
              className="h-12 w-auto"
            />
          </Link>

          {/* Trust badges */}
          <div className="hidden md:flex items-center gap-3">
            <Badge variant="secondary" className="gap-1.5 px-3 py-1">
              <ShieldCheck className="w-3.5 h-3.5 text-[hsl(var(--success))]" />
              501(c)(3) Verified
            </Badge>
            <Badge variant="secondary" className="gap-1.5 px-3 py-1">
              <Lock className="w-3.5 h-3.5 text-[hsl(var(--primary))]" />
              Secure
            </Badge>
          </div>

          {/* CTA */}
          {!isDonationPage && (
            <Link to="/donate">
              <Button className="btn-lift" data-testid="header-donate-button">
                Donate Now
              </Button>
            </Link>
          )}
          {isDonationPage && (
            <Link to="/admin">
              <Button variant="ghost" size="sm">
                Admin
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
